var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1892 31.149L85.2117 28.4633L44.1993 43.3906L51.144 44.0407C51.8001 43.7217 52.4717 43.4212 53.1778 43.1642L86.1892 31.149Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5798 45.5224L41.3919 44.8494C41.741 48.8204 37.4278 53.4434 30.826 55.8743L13.9091 66.8573L21.9335 76.7036L41.9136 60.0108C40.4114 54.9215 43.2272 49.1733 48.5797 45.5222L48.5798 45.5224Z",
    fill: "#592EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7641 44.7759C53.4488 44.8907 53.1488 45.0215 52.8454 45.1498C53.135 48.38 49.2137 52.5178 43.5058 54.981C43.3464 55.6362 43.2512 56.2927 43.2346 56.9487C50.6009 54.0996 55.3088 48.8537 54.4999 44.5082L53.7641 44.7759Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRifle);
export default __webpack_public_path__ + "static/media/Rifle.03cb4e6a5acd879a7fc2c23ee9f0a9bb.svg";
export { ForwardRef as ReactComponent };